class SienTheme {
  constructor() {
    this.cartDrawer = document.querySelector("[data-cart-drawer]");
    this.paymentDialog = document.querySelector("[data-kakao-payment-dialog]");
    this.lastFocus = null;
    this.bindNavigation();
    this.bindProductSorting();
    this.bindProductForms();
    this.bindCart();
  }
  bindProductSorting() {
    const collator = new Intl.Collator("ko-KR", {
      numeric: true,
      sensitivity: "base",
    });
    document.querySelectorAll(".product-grid").forEach((grid) => {
      const cards = [...grid.querySelectorAll(":scope > .product-card")];
      if (cards.length < 2) return;
      cards
        .sort((left, right) => {
          const leftKey = [
            left.dataset.productVendor || "",
            left.dataset.productGroup || "",
            left.dataset.productTitle || "",
          ];
          const rightKey = [
            right.dataset.productVendor || "",
            right.dataset.productGroup || "",
            right.dataset.productTitle || "",
          ];
          for (let index = 0; index < leftKey.length; index += 1) {
            const compared = collator.compare(leftKey[index], rightKey[index]);
            if (compared !== 0) return compared;
          }
          return 0;
        })
        .forEach((card) => grid.appendChild(card));
    });
  }
  bindNavigation() {
    const menu = document.querySelector("[data-mobile-menu]");
    const overlay = document.querySelector("[data-mobile-overlay]");
    const setMenu = (open) => {
      menu?.classList.toggle("is-open", open);
      overlay?.classList.toggle("is-open", open);
      document.body.classList.toggle("is-locked", open);
      document
        .querySelector("[data-menu-open]")
        ?.setAttribute("aria-expanded", String(open));
      if (open) menu?.querySelector("[data-menu-close]")?.focus();
    };
    document
      .querySelectorAll("[data-menu-open]")
      .forEach((button) =>
        button.addEventListener("click", () => setMenu(true)),
      );
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      setMenu(false);
      this.closeCart();
      this.closePayment();
    });
    document
      .querySelectorAll("[data-menu-close], [data-mobile-overlay]")
      .forEach((button) =>
        button.addEventListener("click", () => setMenu(false)),
      );
    document
      .querySelectorAll("[data-announcement-close]")
      .forEach((button) =>
        button.addEventListener("click", () =>
          button.closest(".announcement")?.remove(),
        ),
      );
  }
  bindProductForms() {
    document.querySelectorAll("[data-product-form]").forEach((form) => {
      const select = form.querySelector('[name="id"]');
      const button = form.querySelector('[type="submit"]');
      const variants = JSON.parse(
        form.querySelector("[data-variants-json]")?.textContent || "[]",
      );
      form.querySelectorAll("[data-option-input]").forEach((input) =>
        input.addEventListener("change", () => {
          const chosen = [
            ...form.querySelectorAll("[data-option-input]:checked"),
          ].map((item) => item.value);
          const variant = variants.find((item) =>
            item.options.every((option, index) => option === chosen[index]),
          );
          if (variant && select) select.value = variant.id;
          if (button) {
            button.disabled = !variant || !variant.available;
            button.textContent = variant?.available
              ? button.dataset.addLabel
              : button.dataset.soldLabel;
          }
        }),
      );
      form.addEventListener("submit", (event) => this.addToCart(event, form));
    });
  }
  async addToCart(event, form) {
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button.disabled = true;
    try {
      const body = new FormData(form);
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        body,
      });
      if (!response.ok) {
        const result = await response.json();
        throw new Error(result.description || result.message);
      }
      await this.refreshCart(true);
    } catch (error) {
      window.alert(error.message || "상품을 장바구니에 추가하지 못했습니다.");
    } finally {
      button.disabled = false;
    }
  }
  bindCart() {
    document
      .querySelectorAll("[data-cart-open]")
      .forEach((button) =>
        button.addEventListener("click", () => this.refreshCart(true)),
      );
    document
      .querySelectorAll("[data-cart-close]")
      .forEach((button) =>
        button.addEventListener("click", () => this.closeCart()),
      );
    document
      .querySelectorAll("[data-kakao-payment-open]")
      .forEach((button) =>
        button.addEventListener("click", () => this.openPayment()),
      );
    document
      .querySelectorAll("[data-kakao-payment-close]")
      .forEach((button) =>
        button.addEventListener("click", () => this.closePayment()),
      );
    this.cartDrawer?.addEventListener("click", (event) => {
      if (event.target.matches("[data-cart-drawer]")) this.closeCart();
      const control = event.target.closest("[data-cart-change]");
      if (control)
        this.changeCart(control.dataset.key, Number(control.dataset.quantity));
    });
  }
  openPayment() {
    this.closeCart();
    if (this.paymentDialog?.showModal && !this.paymentDialog.open)
      this.paymentDialog.showModal();
    else this.paymentDialog?.setAttribute("open", "");
    document.body.classList.add("is-locked");
    this.paymentDialog?.querySelector("[data-kakao-payment-close]")?.focus();
  }
  closePayment() {
    if (this.paymentDialog?.open && this.paymentDialog.close)
      this.paymentDialog.close();
    else this.paymentDialog?.removeAttribute("open");
    document.body.classList.remove("is-locked");
  }
  async changeCart(key, quantity) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "same-origin",
          body: JSON.stringify({ id: key, quantity }),
        },
      );
      if (!response.ok) throw new Error("장바구니를 업데이트하지 못했습니다.");
      await this.refreshCart();
    } catch (error) {
      window.alert(error.message || "장바구니를 업데이트하지 못했습니다.");
    }
  }
  async refreshCart(open = false) {
    let cart;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("장바구니를 불러오지 못했습니다.");
      cart = await response.json();
    } catch (error) {
      window.alert(error.message || "장바구니를 불러오지 못했습니다.");
      return;
    }
    document
      .querySelectorAll("[data-cart-count]")
      .forEach((node) => (node.textContent = `(${cart.item_count})`));
    if (!this.cartDrawer) return;
    const body = this.cartDrawer.querySelector("[data-cart-body]");
    const total = this.cartDrawer.querySelector("[data-cart-total]");
    const footer = this.cartDrawer.querySelector("[data-cart-footer]");
    body.innerHTML = cart.items.length
      ? cart.items
          .map(
            (item) => `
      <article class="cart-line">
        <img src="${item.image || ""}" alt="">
        <div><h3>${this.escape(item.product_title)}</h3>${item.variant_title && item.variant_title !== "Default Title" ? `<p>${this.escape(item.variant_title)}</p>` : ""}<p>${this.money(item.final_line_price)}</p><div class="cart-line__controls"><button type="button" data-cart-change data-key="${this.escape(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="수량 줄이기">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-cart-change data-key="${this.escape(item.key)}" data-quantity="${item.quantity + 1}" aria-label="수량 늘리기">+</button><button type="button" data-cart-change data-key="${this.escape(item.key)}" data-quantity="0">삭제</button></div></div>
      </article>`,
          )
          .join("")
      : '<p class="empty-state">장바구니가 비어 있습니다.</p>';
    if (total) total.textContent = this.money(cart.total_price);
    if (footer) footer.hidden = cart.items.length === 0;
    if (open) {
      this.lastFocus = document.activeElement;
      if (this.cartDrawer.showModal && !this.cartDrawer.open)
        this.cartDrawer.showModal();
      else this.cartDrawer.setAttribute("open", "");
      document.body.classList.add("is-locked");
      this.cartDrawer.querySelector("[data-cart-close]")?.focus();
    }
  }
  closeCart() {
    if (this.cartDrawer?.open && this.cartDrawer.close) this.cartDrawer.close();
    else this.cartDrawer?.removeAttribute("open");
    document.body.classList.remove("is-locked");
    this.lastFocus?.focus?.();
  }
  money(cents) {
    return new Intl.NumberFormat("ko-KR", {
      style: "currency",
      currency: window.themeCurrency || "KRW",
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }
  escape(value) {
    const node = document.createElement("div");
    node.textContent = value || "";
    return node.innerHTML;
  }
}
document.addEventListener("DOMContentLoaded", () => new SienTheme());
